import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';

import meta from '../../config/meta';
import env from '../../config/env';

import Header from '../layout/Header.jsx';
import useQuery from '~/commons/hooks/useQuery';
import useHttpStatus from '~/commons/hooks/useHttpStatus';

const PageAssignments = () => {
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({
      url: '/api/quiz/assignments/random-article',
      method: 'POST',
    });
  }, []);
  meta.set({ title: '閱讀任務' });

  return (
    <div>
      <Header
        bg={{
          cover: '/assets/img/assignment_header.png',
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-9 col-lg-8 my-4">
              <div
                className="wordframe"
              >
                <img
                src="/assets/img/assignment_title.svg"
                />
              </div>
            </div>
          </div>
        </div>
      </Header>
        <div className="bg-assignment">
        </div>
    </div>
  );
};

export default PageAssignments;
